<template>
  <div v-if="calls.length" class="broker-calls-list mt-2">
    <div
      v-for="call in visibleCalls"
      :key="call._id || call.call_id"
      class="call-card pa-3 mb-2"
    >
      <div class="d-flex justify-space-between align-center">
        <span class="overline grey--text text--darken-1">Llamada</span>
        <span v-if="call.call_id" class="caption grey--text text--darken-1">
          call_id: {{ call.call_id }}
        </span>
      </div>
      <div class="caption grey--text text--darken-1 mb-1">
        {{ formatDate(call.created_at) }}
      </div>
      <div>
        <v-chip
          v-for="(tag, tagIndex) in call.tags"
          :key="`${tag.tag_id}-${tagIndex}`"
          small
          outlined
          class="mr-1 mb-1"
        >
          <v-icon x-small class="mr-1">mdi-tag-outline</v-icon>
          {{ tag.name }}
        </v-chip>
        <span v-if="!call.tags || !call.tags.length" class="caption grey--text">
          Sin etiquetas
        </span>
      </div>
    </div>

    <div v-if="calls.length > previewCount" class="text-center">
      <v-btn text small color="primary" @click="showAll = !showAll">
        {{ showAll ? "Ver menos" : `Ver ${remainingCount} más` }}
        <v-icon small class="ml-1">
          {{ showAll ? "mdi-chevron-up" : "mdi-chevron-down" }}
        </v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import moment from "moment";
moment.locale("es");

export default {
  name: "BrokerCallsList",
  props: {
    calls: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showAll: false,
      previewCount: 2
    };
  },
  computed: {
    visibleCalls() {
      return this.showAll ? this.calls : this.calls.slice(0, this.previewCount);
    },
    remainingCount() {
      return this.calls.length - this.previewCount;
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return "";
      return moment(date).format("DD MMM YYYY");
    }
  }
};
</script>

<style scoped>
.call-card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
}
</style>
